/* eslint-disable max-len */
import 'react';

const ExternalWarnSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_209_290310" style={{'maskType': 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
            <rect width="20" height="20" fill="black" />
        </mask>
        <g mask="url(#mask0_209_290310)">
            <path d="M10 2.5C14.1421 2.5 17.5 5.85786 17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5Z" fill="#FF7733" />
            <path d="M10 11.3545V6.66699" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 14.167C10.3452 14.167 10.625 13.8872 10.625 13.542C10.625 13.1968 10.3452 12.917 10 12.917C9.65482 12.917 9.375 13.1968 9.375 13.542C9.375 13.8872 9.65482 14.167 10 14.167Z" fill="white" />
        </g>
    </svg>
);
export default ExternalWarnSvg;

